<script>
import { useAlert } from 'dashboard/composables';

export default {
  name: "SettingsModal",
  data() {
    return{
      statusOptions: [
        { value: 'upcoming', label: 'Upcoming' },
        { value: 'requested', label: 'Requested' },
        { value: 'confirmed', label: 'Confirmed' },
        { value: 'rescheduled', label: 'Rescheduled' },
        { value: 'archive', label: 'Archive' },
        { value: 'cancelled', label: 'Cancelled' },
        { value: 'completed', label: 'Completed' },
        { value: 'future', label: 'Future' },
      ],
      trackingStatus: this.$store.state.rentalBranch.trackingStatus || 'requested',
    }
  },
  methods: {
    handleUpdate(){
      this.$store.dispatch('rentalBranch/updateTrackingStatus', this.trackingStatus);
      useAlert('Settings updated.');
    },
  }
}
</script>

<template>
  <div class="z-50 fixed inset-0 flex items-center bg-slate-800/40">
    <div class="overflow-y-auto mx-auto p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-xl min-w-[350px] w-full max-w-md relative">
      <button 
          @click="$emit('close')" 
          class="absolute top-2 right-2 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 text-xl"
          > &times; </button>
      <h2 
        class="text-xl font-semibold mb-4 text-slate-900 dark:text-slate-100"
        >Filter Settings</h2>

      <label>
        Track by
        <select v-model="trackingStatus" @change="handleUpdate">
          <option v-for="filter in statusOptions" :key="filter.value" :value="filter.value">{{ filter.label }}</option>
        </select>
        <p class="text-xs text-slate-500">
          The count of the selected status will be displayed on menu for ease of reference
        </p>
      </label>
    </div>
  </div>
</template>